import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["backgroundColor", "borderRadius"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import { LinearGradient } from '@bubble-ui/atom-linear-gradient';
import { useViewSize } from '@bubble-ui/hook-use-view-size';
import { defaultColorVariables } from '@bubble-ui/particle-default-color-variables';
import { isDarkMode } from '@bubble-ui/particle-design-versions';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { isNative } from '@bubble-ui/util-platform';
import { Box } from '../Box';
import { AnimatedBox } from './helper/Animated';
import { useAnimatedValue } from './helper/useAnimatedValue';
import { ANIMATION_LENGTH, ANIMATION_REPEAT_INTERVAL, MAX_REPEATS } from './config';
export var BoxSkeleton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      backgroundColor = 'colors/backgrounds/subtle-floating',
      borderRadius = 'corner-radius/xs'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var [viewProps, {
    width
  }] = useViewSize();
  var designContext = useDesignContext(_objectSpread({}, defaultColorVariables));
  var designVersion = useDesignVersion();
  var isDark = isDarkMode(designVersion);
  var widthAnimated = useAnimatedValue(width);
  var loadingStyles = _objectSpread({}, isNative ? {
    transform: [{
      translateX: widthAnimated
    }]
  } : {
    animation: "skeleton-".concat(width, " ").concat(ANIMATION_LENGTH + ANIMATION_REPEAT_INTERVAL, "ms ease-in-out ").concat(MAX_REPEATS, " forwards")
  });

  // our transparent token is transparent black, so we hardcode to white
  // otherwise it will not properly blend with the skeleton in native
  var transparent = 'rgba(255, 255, 255, 0)';
  var highlightColor = designContext.get(isDark ? 'colors/backgrounds/inverse' : 'colors/backgrounds/default').withAlpha(isDark ? 0.1 : 0.3).toRGBA();
  return /*#__PURE__*/React.createElement(Box, _extends({
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    overflow: "hidden"
  }, props, viewProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(AnimatedBox, {
    absoluteFill: true
    // @ts-expect-error
    ,
    style: loadingStyles
  }, !isNative ? /*#__PURE__*/React.createElement("style", null, "\n                @keyframes skeleton-".concat(width, " {\n                  0% {transform: translateX(-").concat(width, "px)}\n                  ").concat(ANIMATION_LENGTH / (ANIMATION_LENGTH + ANIMATION_REPEAT_INTERVAL) * 100, "% {transform: translateX(").concat(width, "px);}\n                  100% {transform: translateX(").concat(width, "px);}\n                  }\n                  ").replace(/ {2}|\n/g, '')) : null, /*#__PURE__*/React.createElement(LinearGradient, {
    angle: 90,
    colors: [transparent, highlightColor, transparent],
    locations: [0.2, 0.5, 0.8],
    style: {
      flex: 1
    },
    useAngle: true
  })));
});
BoxSkeleton.displayName = 'Box.Skeleton';
//# sourceMappingURL=index.js.map